<div class="wrapper bg-area">
  <section>
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column">
          <div class="bar__container" style="align-content: center">
            <h3 class="title">Olá {{name}}</h3>
            <p class="description">Clique no botão abaixo para ser redirecionado para área de Cliente!</p>
            <a target="_blank" rel="noopener" class="btn-verde" (click)="goToClient()">
              Ir para área de Cliente
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>

